// This file defines the layers for the North Africa region by merging the non-authenticated and common authenticated TOCs with specific layers for North Africa.
import { non_authenticated, common_authenticated } from '@/constants/layers/index'
import { mergeTocs } from '@/utils/layers'

// Importing non-authenticated and common authenticated TOCs

// Risk layers for North Africa
import buildingsNorthAfrica from './reference/buildingsNorthAfrica'
import countyNorthAfrica from './reference/countyNorthAfrica'
import elevationNorthAfrica from './reference/elevationNorthAfrica'
import incidentsNorthAfrica from './reference/incidentsNorthAfrica'
import landformNorthAfrica from './reference/landformNorthAfrica'
import populationNorthAfrica from './reference/populationNorthAfrica'
import slopeNorthAfrica from './reference/slopeNorthAfrica'
import vegetationNorthAfrica from './reference/vegetationNorthAfrica'
import { burningIndexNorthAfrica } from './riskLayers/burningIndex'
import { energyReleaseNorthAfrica } from './riskLayers/energyReleaseIndex'
import { fireDangerNorthAfrica } from './riskLayers/fireDangeIndex'

// Reference layers for North Africa

// Merging the TOCs and defining the layers for North Africa
// The region's Incidents variant goes first: mergeTocs keeps the first layer with each id
export const northAfricaLayers = mergeTocs(
  [{ name: 'reference', layers: [incidentsNorthAfrica] }],
  non_authenticated.toc,
  common_authenticated.toc,
  [
    { name: 'riskLayers', layers: [burningIndexNorthAfrica, energyReleaseNorthAfrica, fireDangerNorthAfrica] },
    {
      name: 'reference',
      layers: [
        elevationNorthAfrica,
        slopeNorthAfrica,
        landformNorthAfrica,
        populationNorthAfrica,
        vegetationNorthAfrica,
        countyNorthAfrica,
        buildingsNorthAfrica
      ]
    }
    // Add other toc groups if needed
  ]
)
